module.exports = __webpack_public_path__ + "static/media/attention.926f81b9.mp3";